export const isEmailValid: (email: string) => boolean = (email) => {
  const re = /\S+@\S+\.\S{2,}/
  return re.test(email)
}

// Canonical form for case-insensitive email comparison (Clerk and the DB can
// disagree on case/whitespace).
export const normalizeEmail = (email: string) => email.trim().toLowerCase()

export const commonEmailDomains = [
  'aol.com',
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'icloud.com',
  'live.com',
  'mac.com',
  'mail.com',
  'me.com',
  'outlook.com',
  'protonmail.com',
  'yahoo.com',
  'zoho.com',
]

export const isPersonalEmail: (email: string) => boolean = (email) => {
  return commonEmailDomains.some((domain) => email.endsWith(domain))
}

export const isEmailDomainAllowed = (
  domains: string[],
  email: string
): boolean => {
  if (domains.length === 0) {
    return false
  }

  const userDomain = email.split('@')[1]?.toLowerCase()
  if (!userDomain) {
    return false
  }

  return domains.some((domain) => domain.toLowerCase() === userDomain)
}

export const isSlugValid = (text: string): boolean => {
  if (text === '') return false
  return /^[a-z0-9-]+$/.test(text)
}

export const isSalesforceIdValid = (text: string): boolean => {
  return /^[^\s]+$/.test(text) && text === text.toUpperCase()
}
